/**
 * Auth Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.3.4
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CreateAccountRequest { 
    name: string;
    email: string;
    identifier: string;
    password?: string;
    role: CreateAccountRequest.RoleEnum;
    scopes: Array<string>;
    clientId?: string;
    externalClientId?: string;
}
export namespace CreateAccountRequest {
    export type RoleEnum = 'MGMT' | 'CLIENT';
    export const RoleEnum = {
        MGMT: 'MGMT' as RoleEnum,
        CLIENT: 'CLIENT' as RoleEnum
    };
}